module.exports = __webpack_public_path__ + "img/facebook-text.4efc69a6.svg";